export function isToolError(x) {
    return typeof x === "object" && x !== null && "error" in x;
}
export const defaultPolicy = () => ({
    confirm: {
        submits: true,
        externalNav: true,
        denyNamePatterns: [
            /\b(pay|purchase|buy|checkout|place\s+order|subscribe)\b/i,
            /\b(delete|remove|deactivate|close\s+account|cancel\s+subscription)\b/i,
            /\b(send|confirm|submit)\b/i,
        ],
    },
    zones: { deny: [] },
    maxSteps: 25,
    maxTaskSeconds: 180,
});
//# sourceMappingURL=types.js.map